import { useMatches } from "react-router";
import { getLoaderData } from "@app/helpers";
import ClientAdSettingsClientData from "@components/Advertisement/components/ClientAdSettings/ClientAdSettingsData";
import { HttpStatusCode } from "axios";

const ClientAdSettings = (): React.ReactElement => {
  const matches = useMatches();
  const currentMatch = matches[matches.length - 1];
  const loaderData = getLoaderData(currentMatch);

  if (loaderData && loaderData.statusCode !== HttpStatusCode.Ok) return <></>;
  if (typeof loaderData?.payload === "undefined") return <></>;
  if (typeof loaderData?.payload === "string") return <></>;

  const adSettings = loaderData.payload.adSettings;

  if (!adSettings) return <></>;

  return <ClientAdSettingsClientData />;
};

export default ClientAdSettings;
